export const FEATURE_FLAG_TAG = 'Feature Flag';

export const TAGS = [FEATURE_FLAG_TAG];
